import * as React from 'react';
import type { SVGProps } from 'react';

const IconGraph = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53 29" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.324 1.698C35.324.76 36.146 0 37.16 0h13.662c1.014 0 1.835.76 1.835 1.698v12.556c0 .938-.821 1.698-1.835 1.698s-1.836-.76-1.836-1.698V5.78L33.97 19.587c-1.148 1.055-2.137 1.965-3.035 2.595-.963.676-2.033 1.187-3.35 1.187-1.318 0-2.388-.511-3.35-1.188-.899-.63-1.888-1.54-3.035-2.596l-.672-.617c-1.258-1.158-2.074-1.903-2.753-2.38-.637-.447-.935-.497-1.132-.497-.197 0-.495.05-1.131.498-.68.477-1.495 1.223-2.752 2.382l-9.59 8.834c-.72.662-1.881.66-2.597-.005a1.61 1.61 0 0 1 .006-2.4l9.676-8.915c1.148-1.057 2.137-1.968 3.035-2.6.963-.677 2.034-1.19 3.352-1.19s2.389.511 3.352 1.188c.9.63 1.89 1.542 3.038 2.598l.671.618c1.257 1.156 2.072 1.9 2.751 2.377.637.447.934.497 1.131.497.197 0 .495-.05 1.131-.496.679-.477 1.494-1.221 2.752-2.378L46.37 3.396h-9.21c-1.015 0-1.837-.76-1.837-1.698Z"
      fill="#f0ece5"
    />
  </svg>
);

export default IconGraph;
